var map = {
	"./1.png": 2697,
	"./10.png": 89,
	"./2.png": 7064,
	"./3.png": 8226,
	"./4.png": 2837,
	"./5.png": 8663,
	"./6.png": 8071,
	"./7.png": 8405,
	"./8.png": 3754,
	"./9.png": 2077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;